import { Check, X } from "lucide-react";
import { STATUS_OPTIONS, deptName } from "../lib/constants";

const STATE = {
  BEKLIYOR: { label: "Bekliyor", cls: "bg-amber-500/15 text-amber-300 border-amber-500/40" },
  ONAYLANDI: { label: "Onaylandı", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40" },
  REDDEDILDI: { label: "Reddedildi", cls: "bg-rose-500/15 text-rose-300 border-rose-500/40" },
};

const Badge = ({ code }) => {
  const s = STATUS_OPTIONS.find((o) => o.code === code);
  return <span className={`px-2 py-0.5 rounded-full text-[10px] font-mono uppercase border ${s?.cls}`}>{s?.label || code}</span>;
};

export default function CorrectionList({ items, hotelName, onApprove, onReject, busyId }) {
  if (!items.length) return <div className="text-center py-8 text-slate-500 font-mono text-sm">Talep bulunmuyor</div>;
  return (
    <div className="space-y-2">
      {items.map((c) => (
        <div key={c.id} data-testid={`correction-${c.id}`} className="p-3 rounded-lg bg-slate-900/40 border border-cyan-500/15 flex flex-wrap items-center justify-between gap-3">
          <div className="min-w-[220px]">
            <div className="text-sm text-slate-100"><span className="font-mono text-cyan-400 mr-2">#{c.sira_no}</span>{c.full_name}</div>
            <div className="text-[10px] font-mono text-slate-400 uppercase tracking-wider">
              {c.date}{hotelName ? ` · ${hotelName(c.hotel_code)} / ${deptName(c.department_code)} · ${c.requested_by_name}` : ""}
            </div>
            <div className="text-xs text-slate-300 mt-1 italic">"{c.note}"</div>
          </div>
          <div className="flex items-center gap-2">
            <Badge code={c.current_status} /><span className="text-cyan-400">→</span><Badge code={c.requested_status} />
          </div>
          <div className="flex items-center gap-2">
            {onApprove && c.status === "BEKLIYOR" ? (
              <>
                <button data-testid={`approve-${c.id}`} disabled={busyId === c.id} onClick={() => onApprove(c)} className="px-3 py-1.5 rounded-lg border border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/15 font-mono text-[10px] uppercase tracking-widest flex items-center gap-1 disabled:opacity-40"><Check className="w-3.5 h-3.5" /> Onayla</button>
                <button data-testid={`reject-${c.id}`} disabled={busyId === c.id} onClick={() => onReject(c)} className="px-3 py-1.5 rounded-lg border border-rose-500/40 text-rose-300 hover:bg-rose-500/15 font-mono text-[10px] uppercase tracking-widest flex items-center gap-1 disabled:opacity-40"><X className="w-3.5 h-3.5" /> Reddet</button>
              </>
            ) : (
              <span data-testid={`correction-state-${c.id}`} className={`px-2 py-0.5 rounded-full text-[10px] font-mono uppercase border ${STATE[c.status].cls}`}>{STATE[c.status].label}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
